/* eslint-disable quotes */
import { h } from 'vue';

const body = `<h4>Set smoothen strength</h4>

<p>Set how strong you want the smoothening operations to be.</p>

<ul class='shortcuts'>
    <li class='shortcuts__item'><b>Shortcuts:</b></li>
    <li class='shortcuts__item'><b>Shift-ctrl-U</b>: Set smoothen strength</li>
</ul>`;

export function ShowSmoothenOptionsTooltip() {
    return h('div', { innerHTML: body });
}
